define(function avatarModelServiceImpl() {
  'use strict';

  var avatarModelService = function avatarModelService(
    riqApiService,
    cdnAssetService,
    $rootScope
  ) {
    var _this = this;

    riqApiService.setApiEndpoints({
      getAvatar: 'avatar_get'
    });

    var getAvatar = function getAvatar(data) {
      return riqApiService.get('getAvatar', data);
    };

    var getAvatarUrl = function getAvatarUrl(avatarId) {
      return (
        $rootScope.cdnBaseUrl +
        cdnAssetService.getAvatarImagePath({avatarId: avatarId})
      );
    };

    _this.getAvatar = getAvatar;
    _this.getAvatarUrl = getAvatarUrl;
  };

  return avatarModelService;
});
